import { builder } from "@builder.io/react";
import { GetContentOptions } from "@builder.io/sdk";
import { UserAttributes } from "@builder.io/sdk/dist/src/builder.class";
import {
  getLocaleId,
  getSessionCountry,
  isE2E,
} from "@faire/web/builder/BuilderComponents/builderUtils";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import isChromatic from "chromatic/isChromatic";
import { useLocation } from "react-router-dom";

export const useBuilderContentQuery = (
  modelName: string,
  contentOptions?: GetContentOptions
) => {
  const { pathname } = useLocation();
  const userCountry = getSessionCountry();

  // e.g. "en-US", "fr-FR", "de-DE"
  // if not set, use "Default" as the default locale
  const locale = getLocaleId()?.replace("_", "-") ?? "Default";

  const defaultUserAttributes: UserAttributes = {
    locale,
    urlPath: pathname,
    userCountry,
  };
  const enabled = !isE2E() && !isChromatic();

  return useQuery({
    queryKey: [
      modelName,
      defaultUserAttributes,
      locale,
      contentOptions,
      contentOptions?.userAttributes,
      contentOptions?.options,
    ],
    queryFn: () =>
      builder
        .get(modelName, {
          ...contentOptions,
          userAttributes: {
            ...defaultUserAttributes,
            ...contentOptions?.userAttributes,
          },
          options: {
            // locale is required, otherwise text will not appear
            locale,
            ...contentOptions?.options,
          },
        })
        .promise(),
    placeholderData: keepPreviousData,
    staleTime: Infinity,
    enabled,
  });
};
